/* eslint-disable no-use-before-define */
import React, { useEffect, useRef, useState } from 'react';

import { Autocomplete, TextField } from '@mui/material';

import Styles from '../lib/Styles';
import APIService from '../shared/api-service';
import IMake from '../shared/IMake';
import IModel from '../shared/IModel';
import classes from './SelectField.module.scss';

// Class variables used to help determine when the selected makes is changed.
let previousMakes: Array<IMake> | undefined = undefined;
let makeChanged: boolean = true;

export default function SelectModels(props: any) {
  // The list of models retrieved from the server
  const [models, setModels] = useState<Array<IModel>>([]);
  const [loaded, setLoaded] = useState<boolean>(false);
  const { setSelectedModels, onChangeModels, readOnly } = props;
  const selectedMakes: Array<IMake> = props.selectedMakes;
  const selectedModels: Array<IModel> = props.selectedModels;
  let initialValue  = useRef(props.initialValue);
  const cx = new Styles(classes).cx;

  // When the selectedMakes is changed, clear the models and selectedModels and invoke onChangeModel() callback.
  useEffect(() => {
  if (previousMakes !== selectedMakes) {
    previousMakes = selectedMakes;
    makeChanged = true;
    setModels([]);
    onChangeSelectedModels(null, []);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMakes])

  useEffect(() => {
    if (loaded && initialValue.current && models && models.length > 0) {
      let mdls: Array<string> = initialValue.current.split(',').map((item: string) => item.trim());
      let selectedMdls: Array<IModel> = new Array<IModel>();
      for (let i = 0; i < mdls.length; i++) {
        let mdl = mdls[i];
        const index = models.findIndex((item: IModel) => item.Name === mdl);
        if (index >= 0) {
          selectedMdls.push(models[index]);
        }
      }
      setSelectedModels(selectedMdls);
      initialValue.current = undefined;
    }
  }, [loaded, models, setSelectedModels])

  useEffect(() => {
  // If user has selectd a Make or changed the Make then fetch the various models for that makes.
  if (makeChanged && selectedMakes) {
    makeChanged = false;
    const apiService = new APIService();
      const makeIdsAndPriorities: Array<{ Id: string, Priority: number }> = selectedMakes.map((make: IMake) => [{ 'Id': make.Id, 'Priority': make.Priority }]).map((a) => a[0]);

    setLoaded(false);
    apiService.retrieveModels(makeIdsAndPriorities).then((models: void | Array<IModel>) => {
        setModels(models ? models : []);
        setLoaded(true);
    })
  } else if (!selectedMakes) {
    if (!loaded) {
      setLoaded(true);
    }
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMakes]);

  return (
    <div className={cx('root')}>
      <Autocomplete
        disabled={readOnly || (!models || models.length === 0)}
        multiple
        //@ts-ignore
        options={models}
        getOptionLabel={(option: any) => option.Name}
        defaultValue={undefined}
        value={selectedModels}
        filterSelectedOptions
        onChange={onChangeSelectedModels}

        renderInput={(params: any) => (
          <TextField
            {...params}
            variant="outlined"
            label={!loaded ? "Loading Models ..." : selectedMakes && selectedMakes.length > 0 && models && models.length === 0 ? "There are no models on record." : "Models"}
            placeholder={"Select one or more models."}
            fullWidth
          />
        )}
      />
    </div>
  );

  function onChangeSelectedModels(event: any, values: any) {
    setSelectedModels(values);
    onChangeModels();
  }

}
